export function initMapbox(el) {
    import('@mapbox/search-js-web').then((module) => {
        module.autofill({
            accessToken: process.env.MAPBOX_ACCESS_TOKEN,
        })

        const form = el.form;
        // https://docs.mapbox.com/mapbox-search-js/api/web/autofill/#confirmaddress
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            const result = await module.confirmAddress(form, {
                minimap: true,
                accessToken: process.env.MAPBOX_ACCESS_TOKEN,
                skipConfirmModal: (feature) =>
                    ['exact', 'high'].includes(
                        feature.properties.match_code.confidence
                    )
            });

            if (result.type === 'nochange') {
                await htmx.ajax("post", form.action, {
                    source: form,
                });
            }

            if (result.type === 'change') {
                await htmx.ajax("post", form.action, {
                    source: form,
                });
            }
        });
    })
}